module.exports = __webpack_public_path__ + "img/membership_hero_mobile.5fe27296.jpg";